import React from "react";
import * as XLSX from "xlsx";
import { ParseDate } from "../../../../Helpers/DateHelper";
import Button from "react-bootstrap/Button";

const ExcelDownload = ({ candidatesData, fileName, isDisabled }) => {
  // Sample data containing multiple candidates

  const downloadExcel = () => {
    let formattedDataArray = [];

    candidatesData.forEach((candidate) => {
      let formattedData = { ...candidate };
      delete formattedData.questionAnswersJson; // Remove JSON string before formatting
      delete formattedData.checkboxAnswersJson;

      formattedData.creationDate =
        ParseDate(candidate.creationDate).date + " " + ParseDate(candidate.creationDate).time;

      // Parse and merge questions dynamically
      const parsedCheckboxQuestions = JSON.parse(candidate?.checkboxAnswersJson);
      const parsedQuestions = JSON.parse(candidate.questionAnswersJson);
      parsedQuestions?.forEach((question, index) => {
        const selectedAnswer = question.options?.find((option) => option.id === question.answer);

        formattedData[
          `Q${question.leftPolar || question.rightPolar ? "P" : "L"}  ${question.questionId} - ${question.text || question.imagePath || question.leftPolar + " <-> " + question.rightPolar || "N/A"}`
        ] = `${selectedAnswer?.option || question.answer}`;
        if (question.timer) formattedData[`Q${question.questionId}_Timer`] = question.timer;
      });
      parsedCheckboxQuestions?.forEach((checkboxQuestion, index) => {
        if (checkboxQuestion.checked) {
          formattedData[`CB ${checkboxQuestion.questionId} - ${checkboxQuestion.text || "N/A"}`] = `1`;
        } else {
          formattedData[`CB ${checkboxQuestion.questionId} - ${checkboxQuestion.text || "N/A"}`] = `0`;
        }
      });

      formattedDataArray.push(formattedData);
    });

    // Convert data to worksheet
    const ws = XLSX.utils.json_to_sheet(formattedDataArray);

    // 🔹 Dynamically adjust column widths based on content
    const columnHeaders = Object.keys(formattedDataArray[0]); // Get all headers
    const columnWidths = columnHeaders.map((header) => {
      const maxContentLength = Math.max(
        header.length, // Header text length
        ...formattedDataArray.map((row) => (row[header] ? row[header].toString().length : 0)) // Find longest content per column
      );
      return { width: maxContentLength + 5 }; // Add padding
    });

    ws["!cols"] = columnWidths; // Apply dynamic widths

    // Create workbook and append worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Candidates Data");

    // Convert workbook to Blob
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

    // Create a downloadable link and trigger the download
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${fileName}.xlsx`;
    document.body.appendChild(a);
    a.click();

    // Cleanup
    setTimeout(() => {
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }, 100);
  };

  return (
    <Button disabled={isDisabled} onClick={downloadExcel} className={"button primary h-100"}>
      Download Excel
    </Button>
  );
};

export default ExcelDownload;
